/// <reference path="../Bases/GridBase.ts" />
namespace _Ext {

    @Serenity.Decorators.registerClass([Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly])
    @Serenity.Decorators.editor()
    @Serenity.Decorators.element("<div/>")
    export class MFGTransItemGridEditor<TEntity> extends _Ext.GridBase<TEntity, any>
        implements Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly {

        protected get_ExtGridOptions(): ExtGridOptions { return Q.deepClone(q.DefaultEditorGridOptions); }

        protected getIdProperty() { return "__id"; }

        isChildGrid = true;

        protected nextId = 1;

        constructor(container: JQuery) {
            super(container);

            this.slickGrid.onSort.subscribe((e, args) => {
                this.sortGridFunction((args.grid as Slick.Grid), args.sortCols[0], args.sortCols[0].sortCol.field);

                //(args.grid as Slick.Grid).init();
                (args.grid as Slick.Grid).invalidateAllRows();
                (args.grid as Slick.Grid).invalidate();
                (args.grid as Slick.Grid).render();
                (args.grid as Slick.Grid).resizeCanvas();
            });

        }

        private sortGridFunction(grid: Slick.Grid, column: any, field: any) {
            grid.getData().sort(function (a, b) {
                var result = a[field] > b[field] ? 1 :
                    a[field] < b[field] ? -1 :
                        0;
                return column.sortAsc ? result : -result;
            });
        }

        protected getQuickFilters() {
            return [];
        }

        protected id(entity: TEntity) {
            return (entity as any)[this.getIdProperty()];
        }

        protected save(opt: Serenity.ServiceOptions<any>, callback: (r: Serenity.ServiceResponse) => void) {
            var request = opt.request as Serenity.SaveRequest<TEntity>;
            var row = Q.deepClone(request.Entity);

            var id = this.id(row);
            if (id == null) {
                row[this.getIdProperty()] = "`" + this.nextId++;
            }

            if (!this.validateEntity(row, id)) {
                return;
            }

            var items = this.view.getItems().slice();
            if (id == null) {
                items.push(row);
            }
            else {
                var index = Q.indexOf(items, x => this.id(x) === id);
                items[index] = Q.deepClone({} as TEntity, items[index], row);
            }

            this.value = items;
            callback({});
        }

        protected deleteEntity(id: number) {
            this.view.deleteItem(id);
            setTimeout(() => {
                this.onItemsChanged();
                this.element.trigger('change');
                this.resetRowNumber();
            });
            return true;
        }

        protected validateEntity(row: TEntity, id: number) {
            return true;
        }

        protected getNewEntity(): TEntity {
            return {} as TEntity;
        }

        protected getButtons(): Serenity.ToolButton[] {
            return [{
                title: this.getItemName(),
                cssClass: 'add-button',
                onClick: () => { this.addButtonClick() }
            }];
        }

        protected addButtonClick(): void {
            this.createEntityDialog(this.getItemType(), dlg => {
                var dialog = dlg as MFGTransItemEditorDialog<TEntity>;
                dialog.parentEditor = this;
                dialog.onSave = (opt, callback) => this.save(opt, callback);
                dialog.loadEntityAndOpenDialog(this.getNewEntity());
            });
        }

        protected editItem(entityOrId: any): void {

            var id = entityOrId;
            var item = this.view.getItemById(id);
            this.createEntityDialog(this.getItemType(), dlg => {
                var dialog = dlg as MFGTransItemEditorDialog<TEntity>;
                dialog.onDelete = (opt, callback) => {
                    if (!this.deleteEntity(id)) {
                        return;
                    }
                    callback({});
                };
                dialog.parentEditor = this;
                dialog.onSave = (opt, callback) => this.save(opt, callback);
                dialog.loadEntityAndOpenDialog(item);
            });;
        }

        public getEditValue(property, target) {
            target[property.name] = this.value;
        }

        public setEditValue(source, property) {
            this.value = source[property.name];
        }

        public get value(): TEntity[] {
            var p = this.getIdProperty();

            (this.slickGrid as any).getEditController().commitCurrentEdit();

            let items = this.view.getItems();

            this.onBeforeGetValue(items);

            return items.map(x => {
                var y = Q.deepClone(x);
                var id = y[p];
                if (id && id.toString().charAt(0) == '`')
                    delete y[p];

                if (y['RowNum'])
                    delete y['RowNum'];
                return y;
            });
        }

        public set value(value: TEntity[]) {
            var id = this.getIdProperty();

            let val = value || [];

            let items = val.map(x => {
                var y = Q.deepClone(x);
                if ((y as any)[id] == null) {
                    (y as any)[id] = "`" + this.nextId++;
                }
                return y;
            });

            let r = this.onViewProcessData({ Entities: items })
            this.view.setItems(r.Entities, true);
            setTimeout(() => {
                this.onItemsChanged();
                this.element.trigger('change');
            });
            this.resetRowNumber(); // to generate serial no.
        }

        protected getGridCanLoad() {
            return false;
        }

        protected usePager() {
            return false;
        }

        protected getInitialTitle() {
            return null;
        }

        private searchText: string;

        protected createToolbarExtensions(): void {
            //super.createToolbarExtensions();
            if (this.get_ExtGridOptions().EnableQuickSearch) {
                Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text) => {
                    this.searchText = Select2.util.stripDiacritics(Q.trimToNull(text) || '').toLowerCase();
                    this.view.setItems(this.view.getItems(), true);
                });
            }
        }

        protected onViewFilter(row): boolean {
            if (!super.onViewFilter(row)) {
                return false;
            }

            if (this.searchText) {
                return this.matchContains(row);
            }

            return true;
        }

        private matchContains(item): boolean {
            let result = false;

            for (let prop in item) {
                result = Select2.util.stripDiacritics(String(item[prop] || '')).toLowerCase().indexOf(this.searchText) >= 0;

                if (result == true) {
                    return result;
                }
            }

            return result;
        }

        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        protected enableFiltering(): boolean { return false; }

        protected onViewSubmit() { return false; }

        get_readOnly(): boolean {
            return this.isReadOnly;
        }
        set_readOnly(value: boolean): void {
            this.isReadOnly = value;
            if (value == true) {
                this.element.find('.add-button').addClass('disabled');
                this.element.find('.stock-button').addClass('disabled');
                this.element.find('.approval-button').addClass('disabled');
                this.element.find('.order-button').addClass('disabled');
                let opt = this.slickGrid.getOptions();
                opt.editable = false;

                this.slickGrid.setOptions(opt);
            } else {
                this.element.find('.add-button').removeClass('disabled');
                this.element.find('.stock-button').removeClass('disabled');
                this.element.find('.approval-button').removeClass('disabled');
                this.element.find('.approval-button').removeClass('disabled');
            }

        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.forceFitColumns = false;
            //opt.autoHeight = true; // If you need to show footer, you have to do opt.autoHeight = false
            return opt;
        }

        parentDialog: MFGTransDialog<any, any>;

        //custom events
        onItemsChanged() {

        }
        onBeforeGetValue(items: TEntity[]) {

        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as any;
            //To Set Master Product Image
            this.parentDialog.Image = item.ImageName;
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
            if (target.hasClass('edit')) {
                if (this.isReadOnly) {
                    target.addClass('readonly');
                    target.blur();
                    q.Alert("View Mode", "Can not make changes in view mode", 2000, true);
                }
            }

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    if (this.isReadOnly) {
                        q.Alert("View Mode", "Can not make changes in view mode", 2000, true);
                    }
                    else {
                        //TODO: Validate for TransItemID in RefTransItemID in Stock
                        q.information('Are you sure want to Delete?', '', true, () => {
                            var id = this.id(item);
                            var refId = 0;
                            if (!Q.isEmptyOrNull(item.TransItemId))
                            TabAurous.Production.WIPMovementService.RefList({
                                RefVoucherId: item.VoucherTypeId,
                                RefTransId: item.TransId,
                                RefTransItemId: item.TransItemId
                            },
                                response => refId = response.Entities.length,
                                { async: false }
                            );

                            if (refId > 0) {
                                q.Alert("Can not delete!", "This Item has been used in transactions Cannot Delete!", 2500, false);
                                return;
                            } else {
                                this.view.deleteItem(id);
                            }
                        }, () => { });
                    }
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }

            if (target.hasClass('edit numeric')) {
                e.preventDefault();
                //TODO: Need to add System Parameter to enable disable blocking
                var input = $(e.target);
                if (input != undefined) {
                    if (this.isReadOnly) {
                        //Check Editable
                        target.addClass('readonly');
                        target.blur();
                        q.Alert("View Mode", "Can not make changes in view mode", 2000, true);
                    }
                    else if (!this.isReadOnly) {
                        target.removeClass('readonly');
                        var input = $(e.target);
                        var y = input.data();
                         if (y.field == "UnitRate" && item.ItemTypeId == 101 && item.HasBom) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        }
                    }
                }
                this.view.refresh();
            }
        }
    }
}